import React from "react"
import { Query } from "react-apollo"
import { Redirect } from "react-router-dom"
import { Helmet } from "react-helmet"
import { MetaData, structureTopicData } from "../../shared/structureData"
import { DEFAULT_LOGO, TOPIC_TYPE } from "../../shared/constants"
import RelatedProducts from "./components/relatedProducts"
import VendorPage from "./components/vendorPage"
import SectorPage from "./components/sectorPage"
import { getSectorPage, getVendorPage } from "./queries"

import "./style.scss"

const TopicsPage = (props) => {
  const { viewer, match, history } = props
  const { params } = match

  const hasTopicType = params && params.type
  const typeToLowercase = hasTopicType ? params.type.toLowerCase() : null
  const isVendor = typeToLowercase === TOPIC_TYPE.VENDOR
  const isSector = typeToLowercase === TOPIC_TYPE.SECTOR
  const topicQuery =
    typeToLowercase === TOPIC_TYPE.VENDOR ? getVendorPage : getSectorPage

  const renderSEO = (topic) => {
    const {
      name,
      type,
      description,
      previewDescription,
      totalPrice,
      logo,
    } = topic

    const seoType = "product.group"
    const pageURL = type
      ? `https://app.etr.ai/${type.toLowerCase()}/${name.toLowerCase()}`
      : ""
    const pageDescription = previewDescription || description || null

    const seo = {
      url: pageURL,
      title: `${name} | ETR`,
      image: logo || DEFAULT_LOGO,
      type: seoType,
      description: pageDescription,
      name,
      totalPrice: totalPrice || null,
    }

    return (
      <Helmet>
        {MetaData(seo)}
        <script type="application/ld+json">{structureTopicData(seo)}</script>
      </Helmet>
    )
  }

  let queryVariables = {
    ...params,
  }

  return (
    <Query
      query={topicQuery}
      variables={queryVariables}
      fetchPolicy={"network-only"}
    >
      {({ data, error }) => {
        if (error) {
          console.error("Error while getting Topic page: ", error)
          return <Redirect to="Not-Found" />
        }

        if (data && data.page && data.siteSettings) {
          const { page, siteSettings } = data
          return (
            <>
              <div className="topics-page">
                <div className="topic-container">
                  {renderSEO(page)}
                  {isVendor && (
                    <VendorPage
                      topic={page}
                      viewer={viewer}
                      history={history}
                      settings={siteSettings}
                    />
                  )}
                  {isSector && <SectorPage topic={page} {...props} />}
                </div>
              </div>
              <p className="related-products-header">
                <span>Related Reports </span> Discover insights about{" "}
                {page.name} and other related companies in compariable sectors{" "}
              </p>
              <RelatedProducts topic={page} />
            </>
          )
        }
        return null
      }}
    </Query>
  )
}

export default TopicsPage
